// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var Expln_utils_data = require("@expln/utils/src/main/Expln_utils_data.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");

var MmException = /* @__PURE__ */Caml_exceptions.create("MM_parser.MmException");

function isWhitespace(str) {
  if (str === " " || str === "\t" || str === "\n") {
    return true;
  } else {
    return str === "\r";
  }
}

function textAt(text, i) {
  var textLength = text.length;
  var ellipsis = (i + 20 | 0) < textLength ? "..." : "";
  return "'" + text.substr(i, 20) + ellipsis + "'";
}

function parseMmFile(text, onProgressOpt, param) {
  var onProgress = onProgressOpt !== undefined ? onProgressOpt : (function (param) {
        
      });
  var textLength = text.length;
  var idx = {
    contents: 0
  };
  var endOfFile = {
    contents: false
  };
  var ch = {
    contents: ""
  };
  var progressTracker = {
    contents: MM_progress_tracker.progressTrackerMake(0.1, undefined, onProgress, true, undefined)
  };
  var allLabels = [];
  var setIdx = function (i) {
    idx.contents = i;
    if (idx.contents >= textLength) {
      endOfFile.contents = true;
      ch.contents = "";
    } else {
      endOfFile.contents = false;
      ch.contents = text.charAt(idx.contents);
    }
  };
  setIdx(0);
  var readNextChar = function (param) {
    if (!endOfFile.contents) {
      idx.contents = idx.contents + 1 | 0;
      if (idx.contents >= textLength) {
        endOfFile.contents = true;
        ch.contents = "";
      } else {
        ch.contents = text.charAt(idx.contents);
      }
      return ;
    }
    
  };
  var skipWhitespaces = function (param) {
    while(!endOfFile.contents && isWhitespace(ch.contents)) {
      readNextChar(undefined);
    };
  };
  var readAllTextTill = function (tillToken) {
    var result;
    var beginIdx = idx.contents;
    while(Belt_Option.isNone(result)) {
      var foundIdx = text.indexOf(tillToken, idx.contents);
      if (foundIdx < 0) {
        result = Caml_option.some(undefined);
      } else {
        var nextIdx = foundIdx + tillToken.length | 0;
        setIdx(nextIdx);
        if (endOfFile.contents || isWhitespace(ch.contents)) {
          result = Caml_option.some(text.substring(beginIdx, foundIdx));
        } else {
          setIdx(foundIdx + 1 | 0);
        }
      }
    };
    return Belt_Option.getExn(result);
  };
  var parseComment = function (beginIdx) {
    var commentText = readAllTextTill("$)");
    if (commentText !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: /* Comment */0,
                text: commentText
              }
            };
    }
    throw {
          RE_EXN_ID: MmException,
          _1: {
            msg: "A comment is not closed at " + textAt(text, beginIdx) + ""
          },
          Error: new Error()
        };
  };
  var readNextToken = function (skipCommentsOpt, param) {
    var skipComments = skipCommentsOpt !== undefined ? skipCommentsOpt : true;
    if (skipComments) {
      var nextToken = readNextToken(false, undefined);
      while(nextToken === "$(") {
        parseComment(idx.contents);
        nextToken = readNextToken(false, undefined);
      };
      return nextToken;
    }
    skipWhitespaces(undefined);
    var beginIdx = idx.contents;
    while(!endOfFile.contents && !isWhitespace(ch.contents)) {
      readNextChar(undefined);
    };
    return text.substring(beginIdx, idx.contents);
  };
  var readAllTokensTill = function (tillToken) {
    var result;
    var tokens = [];
    while(Belt_Option.isNone(result)) {
      var token = readNextToken(undefined, undefined);
      if (token === "") {
        result = Caml_option.some(undefined);
      } else if (token === "$(") {
        parseComment(idx.contents);
      } else if (token === tillToken) {
        result = Caml_option.some(tokens);
      } else {
        tokens.push(token);
      }
    };
    return Belt_Option.getExn(result);
  };
  var parseConst = function (beginIdx) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: /* Const */1,
                symbols: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: MmException,
          _1: {
            msg: "A constant statement is not closed at " + textAt(text, beginIdx) + ""
          },
          Error: new Error()
        };
  };
  var parseVar = function (beginIdx) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: /* Var */3,
                symbols: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: MmException,
          _1: {
            msg: "A variable statement is not closed at " + textAt(text, beginIdx) + ""
          },
          Error: new Error()
        };
  };
  var parseDisj = function (beginIdx) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: /* Disj */4,
                vars: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: MmException,
          _1: {
            msg: "A disjoint statement is not closed at " + textAt(text, beginIdx) + ""
          },
          Error: new Error()
        };
  };
  var parseFloating = function (beginIdx, label) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: /* Floating */5,
                label: label,
                expr: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: MmException,
          _1: {
            msg: "A floating statement is not closed at " + textAt(text, beginIdx) + ""
          },
          Error: new Error()
        };
  };
  var parseEssential = function (beginIdx, label) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: /* Essential */6,
                label: label,
                expr: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: MmException,
          _1: {
            msg: "An essential statement is not closed at " + textAt(text, beginIdx) + ""
          },
          Error: new Error()
        };
  };
  var parseAxiom = function (beginIdx, label) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: /* Axiom */7,
                label: label,
                expr: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: MmException,
          _1: {
            msg: "An axiom statement is not closed at " + textAt(text, beginIdx) + ""
          },
          Error: new Error()
        };
  };
  var parseProvable = function (beginIdx, label) {
    var expression = readAllTokensTill("$=");
    if (expression !== undefined) {
      var firstProofToken = readNextToken(undefined, undefined);
      if (firstProofToken === "(") {
        var proofLabels = readAllTokensTill(")");
        if (proofLabels !== undefined) {
          var compressedProofBlocks = readAllTokensTill("$.");
          if (compressedProofBlocks !== undefined) {
            return {
                    begin: beginIdx,
                    end: idx.contents - 1 | 0,
                    stmt: {
                      TAG: /* Provable */8,
                      label: label,
                      expr: expression,
                      proof: {
                        TAG: /* Compressed */1,
                        labels: proofLabels,
                        compressedProofBlock: Caml_splice_call.spliceObjApply("", "concat", [compressedProofBlocks])
                      }
                    }
                  };
          }
          throw {
                RE_EXN_ID: MmException,
                _1: {
                  msg: "A probale statement is not closed[3] at " + textAt(text, beginIdx) + ""
                },
                Error: new Error()
              };
        }
        throw {
              RE_EXN_ID: MmException,
              _1: {
                msg: "A provable statement is not closed[2] at " + textAt(text, beginIdx) + ""
              },
              Error: new Error()
            };
      }
      var proofLabels$1 = readAllTokensTill("$.");
      if (proofLabels$1 !== undefined) {
        return {
                begin: beginIdx,
                end: idx.contents - 1 | 0,
                stmt: {
                  TAG: /* Provable */8,
                  label: label,
                  expr: expression,
                  proof: {
                    TAG: /* Uncompressed */0,
                    labels: [firstProofToken].concat(proofLabels$1)
                  }
                }
              };
      }
      throw {
            RE_EXN_ID: MmException,
            _1: {
              msg: "A provable statement is not closed[4] at " + textAt(text, beginIdx) + ""
            },
            Error: new Error()
          };
    }
    throw {
          RE_EXN_ID: MmException,
          _1: {
            msg: "A provable statement is not closed[1] at " + textAt(text, beginIdx) + ""
          },
          Error: new Error()
        };
  };
  var parseBlock = function (beginIdx, level) {
    var result;
    var statements = [];
    while(Belt_Option.isNone(result)) {
      var token = readNextToken(false, undefined);
      var tokenIdx = idx.contents - token.length | 0;
      if (token === "") {
        if (level === 0) {
          result = {
            begin: beginIdx,
            end: idx.contents - 1 | 0,
            stmt: {
              TAG: /* Block */2,
              level: level,
              statements: statements
            }
          };
        } else {
          throw {
                RE_EXN_ID: MmException,
                _1: {
                  msg: "Unexpected end of a block. The block begins at " + textAt(text, beginIdx) + " and is not closed."
                },
                Error: new Error()
              };
        }
      } else if (token === "$}") {
        result = {
          begin: beginIdx,
          end: idx.contents - 1 | 0,
          stmt: {
            TAG: /* Block */2,
            level: level,
            statements: statements
          }
        };
      } else if (token === "${") {
        var stmt = parseBlock(tokenIdx, level + 1 | 0);
        statements.push(stmt);
      } else if (token === "$(") {
        var stmt$1 = parseComment(tokenIdx);
        statements.push(stmt$1);
      } else if (token === "$c") {
        var stmt$2 = parseConst(tokenIdx);
        statements.push(stmt$2);
      } else if (token === "$v") {
        var stmt$3 = parseVar(tokenIdx);
        statements.push(stmt$3);
      } else if (token === "$d") {
        var stmt$4 = parseDisj(tokenIdx);
        statements.push(stmt$4);
      } else {
        var token2 = readNextToken(undefined, undefined);
        var token2Idx = idx.contents - token2.length | 0;
        if (token2 === "") {
          throw {
                RE_EXN_ID: MmException,
                _1: {
                  msg: "Unexpected end of file at " + textAt(text, tokenIdx) + ""
                },
                Error: new Error()
              };
        }
        if (token2 === "$f") {
          var stmt$5 = parseFloating(tokenIdx, token);
          statements.push(stmt$5);
        } else if (token2 === "$e") {
          var stmt$6 = parseEssential(tokenIdx, token);
          statements.push(stmt$6);
        } else if (token2 === "$a") {
          allLabels.push(token);
          var stmt$7 = parseAxiom(tokenIdx, token);
          statements.push(stmt$7);
        } else if (token2 === "$p") {
          allLabels.push(token);
          var stmt$8 = parseProvable(tokenIdx, token);
          statements.push(stmt$8);
        } else {
          throw {
                RE_EXN_ID: MmException,
                _1: {
                  msg: "Unexpected token '" + token2 + "' at " + textAt(text, token2Idx) + ""
                },
                Error: new Error()
              };
        }
      }
      progressTracker.contents = MM_progress_tracker.progressTrackerSetCurrPct(progressTracker.contents, tokenIdx / textLength);
    };
    return Belt_Option.getExn(result);
  };
  var rootAst = parseBlock(idx.contents, 0);
  return [
          rootAst,
          allLabels
        ];
}

function traverseAst(context, root, preProcess, $$process, postProcess, param) {
  return Expln_utils_data.traverseTree(context, root, (function (param, node) {
                var match = node.stmt;
                if (match.TAG === /* Block */2) {
                  return match.statements;
                }
                
              }), preProcess, $$process, postProcess, undefined);
}

function stmtToStr(node) {
  var match = node.stmt;
  switch (match.TAG | 0) {
    case /* Comment */0 :
        return "$( " + match.text + " $)";
    case /* Const */1 :
        return "$c " + match.symbols.join(" ") + " $.";
    case /* Block */2 :
        return "block(level=" + String(match.level) + ")";
    case /* Var */3 :
        return "$v " + match.symbols.join(" ") + " $.";
    case /* Disj */4 :
        return "$d " + match.vars.join(" ") + " $.";
    case /* Floating */5 :
        return match.label + " $f " + match.expr.join(" ") + " $.";
    case /* Essential */6 :
        return match.label + " $e " + match.expr.join(" ") + " $.";
    case /* Axiom */7 :
        return match.label + " $a " + match.expr.join(" ") + " $.";
    case /* Provable */8 :
        var proof = match.proof;
        var tmp;
        tmp = proof.TAG === /* Uncompressed */0 ? proof.labels.join(" ") : "...";
        return match.label + " $p " + match.expr.join(" ") + " $= " + tmp + " $.";
    
  }
}

function stmtToStrRec(stmt) {
  var match = traverseAst([
        {
          contents: 0
        },
        []
      ], stmt, (function (param, node) {
          var level = param[0];
          var match = node.stmt;
          if (match.TAG === /* Block */2) {
            var newLevel = match.level;
            if (newLevel !== 0) {
              param[1].push("    ".repeat(level.contents) + "${");
            }
            level.contents = newLevel;
          }
          
        }), (function (param, node) {
          var str;
          str = node.stmt.TAG === /* Block */2 ? "" : stmtToStr(node);
          if (str !== "") {
            param[1].push("    ".repeat(param[0].contents) + str);
          }
          
        }), (function (param, node) {
          var level = param[0];
          var match = node.stmt;
          if (match.TAG === /* Block */2) {
            var newLevel = match.level;
            level.contents = newLevel - 1 | 0;
            if (newLevel !== 0) {
              param[1].push("    ".repeat(level.contents) + "$}");
            }
            
          }
          
        }), undefined);
  return match[0][1];
}

var whitespaceDelimRegex = /[\s\n\r]/;

function getSpaceSeparatedValuesAsArray(str) {
  return str.split(whitespaceDelimRegex).map(function (so) {
                return Belt_Option.getWithDefault(so, "").trim();
              }).filter(function (s) {
              return s.length > 0;
            });
}

exports.MmException = MmException;
exports.parseMmFile = parseMmFile;
exports.textAt = textAt;
exports.traverseAst = traverseAst;
exports.stmtToStr = stmtToStr;
exports.stmtToStrRec = stmtToStrRec;
exports.getSpaceSeparatedValuesAsArray = getSpaceSeparatedValuesAsArray;
/* No side effect */
